<template>

  <t-dialog-form :generalErrors="generalErrors" large :title="t(command) + ' Conteúdo'"
                 :ok-text="t(command) + ' Conteúdo'" @show="showModal" @hidden="resetModal" :busy="busy" :id="id"
                 :status="status" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">


    <t-input v-model="form.checklistContentId" hidden/>

    <t-input v-model="form.typeContent" radio :options="ContentType.list" label="Tipo" required/>

    <t-input v-model="form.title" :add-error="error.title" label="Título" required/>

    <label>Conteúdo</label>
    <vue-editor
        id="editor-sm"
        ref="editorComment"
        class="editorSmall"
        :editor-toolbar="customToolbar"
        :disabled="status === 'sending'"
        v-model="form.content">
    </vue-editor>

    <div class="divider"></div>

    <div class="card-title">Imagens</div>
    <ChecklistContentFile v-if="form.checklistContentId > 0" type-image :foreign-key="form.checklistContentId"/>

  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import ContentType from "@/model/types/resource/ContentType";
import {VueEditor} from "vue2-editor";
import ChecklistContentFile from "@/views/modules/checklist/ChecklistContentFile";
import ui from "@/assets/scripts/ui";


export default {
  name: 'ChecklistContentDialog',
  components: {tDialogForm, VueEditor, ChecklistContentFile},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      ContentType,
      id: "modal-checklist-content-dialog",
      path: "checklist/content", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      primaryKeyColumn: "checklistContentId",
      foreignKeyColumn: "checklistId", //Utilizar quando usar Tabs com outros componentes
      form: {
        checklistId: this.foreignKey,
        checklistContentId: this.primaryKey,
        title: "",
        content: "",
        typeContent: ContentType.type.BEFORE,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend

      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
      ],

    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.busy = true

      //Limpa os campos
      this.resetModal()


      //Setar alguma informações padrão por exemplo vindo de fora
      this.originalGroupUserOptions = []
      this.form.checklistContentId = this.primaryKey
      this.form.checklistId = this.foreignKey
      this.form.typeContent = ContentType.type.BEFORE
      this.form.title = ""
      this.form.content = ""
      this.form.status = 1


      //Coreção para atualização de chave
      setTimeout(async () => {

        //Habilita novamente para forçar geração de chave temporária
        this.genKey = true

        await this.readModal(false)
        this.busy = false

      }, 50)

    },

    async onSubmit() {

      //Corrigir strong por b
      this.form.content = ui.prepareHTML(this.form.content,5000)

      //Validações específicas da tela
      await this.setSubmitDialogDefault()

    },

  },


  //--------------------------------------------------------------------------------------
  //Início de métodos personalizados desta tela


  //--------------------------------------------------------------------------------------

}
</script>
